import type {
  KeyBundleResponse,
  UploadBundleRequest,
  OneTimePreKey,
} from "../types";

let kdsBaseUrl = "";

export function setKdsBaseUrl(url: string): void {
  kdsBaseUrl = url.replace(/\/$/, "");
}

function getHeaders(token: string): HeadersInit {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export async function uploadBundle(
  token: string,
  deviceId: string,
  bundle: UploadBundleRequest,
): Promise<void> {
  const res = await fetch(
    `${kdsBaseUrl}/api/v1/users/me/devices/${deviceId}/bundle`,
    {
      method: "PUT",
      headers: getHeaders(token),
      body: JSON.stringify(bundle),
    },
  );
  if (!res.ok) {
    throw new Error(`KDS upload failed: ${res.status} ${await res.text()}`);
  }
}

export async function fetchBundle(
  userId: string,
  deviceId: string,
): Promise<KeyBundleResponse | null> {
  const res = await fetch(
    `${kdsBaseUrl}/api/v1/users/${userId}/devices/${deviceId}/bundle`,
  );
  if (res.status === 404) return null;
  if (!res.ok) {
    throw new Error(`KDS fetch failed: ${res.status} ${await res.text()}`);
  }
  return res.json();
}

export async function replenishPreKeys(
  token: string,
  deviceId: string,
  preKeys: OneTimePreKey[],
): Promise<void> {
  const res = await fetch(
    `${kdsBaseUrl}/api/v1/users/me/devices/${deviceId}/prekeys`,
    {
      method: "POST",
      headers: getHeaders(token),
      body: JSON.stringify({ oneTimePreKeys: preKeys }),
    },
  );
  if (!res.ok) {
    throw new Error(`KDS replenish failed: ${res.status} ${await res.text()}`);
  }
}
